const iconNames = [
  "diamond",
  "typeSquare",
  "typeCircle",
  "typeTriangle",

  "person",
  "people",

  "map",
  "route",
  "cursor",

  "star",
  "pin",
  "flag",
  "clock",
  "hourglass",

  "book",
  "document",
  "mail",
  "scroll",
  "archive",
  "checkedBox",
  "comment",
  "comments",
  "pen",
  "image",
  "film",
  "music",

  "bulb",
  "mortar",
  "case",
  "gavel",
  "scales",
  "award",

  "house",
  "organisation",
  "government",
  "community",
  "pagoda",
  "swords",

  "testTube",
  "pill",
  "crown",
  "currency",
  "key",
  "mask",
  "wrench",
  "cake",
  "heart",
  "droplet",
  "palette",
  "food",
  "paw",

  "sun",
  "moon",
  "sapling",

  "rewind",
  "fastForward",
  "cube",
  "puzzle",

  "infoIcon",
  "alertIcon",
  "questionIcon",
  "happy",
  "neutral",
  "unhappy"
];

export default iconNames;
